import { Link } from 'react-router-dom';
import { SEO } from '@/components/SEO';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export function LearningPage() {
  return (
    <>
      <SEO title="Learning & Development - Nestor" description="Training programs, certifications, and learning paths for continuous growth" />
      <section className="bg-gradient-to-b from-primary/10 via-background to-background py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Learning & Development</h1>
            <p className="text-xl text-muted-foreground mb-8">Upskill your workforce with structured training and certification programs</p>
            <Button size="lg" asChild><Link to="/demo">Request Demo <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
          </div>
        </div>
      </section>
    </>
  );
}
